/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.0.1
 */

import moment from 'moment';

import { EFormatData } from '../../../../types/widgetTypes';
import { IWidgetSubscriberMaxCostsConfiguration } from '../widgetSubscriberMaxCostsType';

export const widgetSubscriberMaxCostsConfiguration: IWidgetSubscriberMaxCostsConfiguration = {
    currentMonth: moment().month(),
    firstDayInMonth: moment().startOf('month').format(EFormatData.OnlyDay),
    lastDayInMonth: moment().format(EFormatData.OnlyDay),
};
